<template>
    <div class="appointmentR">
        <div>
            <h2>{{ tit }}</h2>
            <Row class="appointment-cont">
                {{ msg }}
                <Col span="24">

                <div class="box-input">
                    <Input v-model="name" placeholder="* 请输入姓名" />
                </div>
                </Col>
                <Col span="24">
                <div class="box-input">
                    <Input v-model="mobile" placeholder="* 请输入手机号" />
                </div>
                </Col>
                <Col span="24" v-if="recordType!=1">
                    <div class="box-input" >
                        <Input v-model="companyName" placeholder="公司" />
                        <span class="ftip-txt">（非必填）</span>
                    </div>
                </Col>
                <Col span="24" v-if="recordType!=1">
                    <div class="box-input">
                        <Select v-model="industry" placeholder="行业" style="width:100%">
                            <Option style="width:80px;" v-for="item in industryList" :value="item.name" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </div>
                </Col>
                <Col span="24" v-if="recordType==0">
                    <div class="box-input">
                        <Select v-model="demand" placeholder="需求" style="width:100%">
                            <Option v-for="item in demandList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </div>
                </Col>
                <Col span="24" v-if="recordType==1">
                    <div class="box-input">
                        <Select v-model="interestCommunity" placeholder="兴趣社团" style="width:100%">
                            <Option v-for="item in shetuanList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </div>
                </Col>
                <!--<Col span="24">
                <div class="box-input">
                    <Input v-model="verifyCode">
                    <Button slot="prepend" @click="sendVerificationCode" :loading="saving">获取验证码</Button>
                    </Input>
                </div>
                </Col>-->
                <Col span="24">
                <div class="box-input">
                    <div class="tip-check">
                        <Checkbox v-model="single">我已阅读并同意<a @click="modal1 = true">《隐私政策》</a>。</Checkbox>
                    </div>
                    <div>
                        <Button class="appoint-btn" type="warning" @click="saveEntrust" :loading="saving">{{ btnTxt }}</Button>
                    </div>
                </div>
                </Col>
            </Row>
        </div>
        <Modal
                v-model="modal1"
                title="隐私政策"
                class-name="vertical-center-modal"
                fullscreen
        >
            <h2>隐私政策</h2>
            <p>感谢您访问盛大天地运营（“盛大天地”“我们”、“本公司”或“我们的”）网站。我们致力于保护本网站（“本网站”）访问者的隐私及安全。请仔细阅读本隐私政策（“隐私政策”），了解我们一般如何收集您的个人身份信息，以及我们可能如何使用和披露该等个人信息。当您于本网站向我们提供您的个人信息后即表示您已充分阅读、理解并接受本隐私政策的全部内容。</p>
            <p>本隐私政策是本网站使用条款（“使用条款”）的一部分并纳入该条款，该使用条款约束您对本网站的使用。在使用本网站前，请先阅读使用条款。</p>
            <p>使用本网站或提供任何个人信息即表示同意本隐私政策。如果您（以及您的委托人）不同意所有使用条款（包括本政策），请不要使用本网站或提供信息（或允许他人代表您这么做）。</p>
            <p>本网站还可能提供第三方网站的链接供您参考。一旦您访问这些第三方网站的链接，您将会离开本网站。这些第三方网站的隐私政策可能与我们的隐私政策不同。本隐私政策不适用于您向任何第三方提供的个人信息。我们不监控或控制第三方网站所收集的信息或任何第三方的隐私政策，也不对任何第三方网站的隐私政策或内容承担任何责任。</p>
            <h2>信息收集</h2>
            <p>我们可能会通过您自愿提交的内容来收集信息。是否提供个人信息，如姓名、电话号码、邮寄地址、电子邮件地址、公司行业、租赁需求或其他有关您本人的个人身份信息（“个人信息”），始终是您或您的任何代理人的选择。不过，为了获得我们提供的某些材料和服务以及使用网站的某些功能，您将需要为我们提供关于您本人的个人信息。因此，决定不提供这些信息将限制或取消您获得某些材料或使用网站某些功能的能力。</p>
            <p>我们还会使用 cookie，以便更好地了解访问者如何使用我们的网站，从而继续改进它。我们可能会收集以下信息：您用于互联网接入的域名和主机；您的起始网站的互联网地址；访问的日期和时间；您的计算机的 IP 地址以及有关操作系统、浏览器和主机的信息；您访问本网站的日期和时间以及访问的页面。如果您不想接收 cookie，可以将浏览器设置为拒绝 cookie。但是，如果关闭 cookie，您可能无法访问本网站的某些服务和功能。</p>
            <h2>信息的使用和披露</h2>
            <p>
                一般来说，我们会使用在本网站收集的信息来完成我们的任务，并从事信息收集的目标活动。具体来说，我们会将您的信息用于：<br/>
                – 与您联系、沟通我们的使命、操作、服务和活动；<br/>
                – 向您发送与我们的活动及/或服务有关的通知、信息；<br/>
                – 分析访问者反馈和跟踪网站使用数据，以改进本网站和其他内部用途；<br/>
                –数据合并、数据存储、客户信息管理、报告和其它内部用途；<br/>
                – 遵守法律或真诚相信该等行为是遵守法律规定或遵循要求本公司履行的法律程序所必需的；和/或<br/>
                – 征得您的同意的其他活动。
            </p>
            <p>
                除下列情况外，我们不会与其他组织共享或以其他方式披露任何个人信息：<br/>
                – 仅出于您提供个人信息的目的或我们在您提供个人信息时披露的任何其他目的，向关联公司、员工、合作伙伴、承包商或代理共享或披露；<br/>
                – 与国家安全、国防安全、公共利益直接相关；<br/>
                -遵循任何法院命令、法律或政府部门要求；<br/>
                – 与内部或外部审计相关；或<br/>
                – 征得您的同意。
            </p>
            <p>当您希望本网站停止收集、使用您的个人信息，您可通过cooperation@shandaworld.cn联系我们。</p>
            <h2>隐私政策变更</h2>
            <p>请注意，本隐私政策可能会在未来发生变更。在我们变更本隐私政策后，如您继续使用本网站，即被视为接受这些变更，因此请检查本网站的这一部分是否有任何修改，如果您不同意更新后的隐私政策内容，请不要使用本网站或提供信息（或允许他人代表您这么做）。</p>
            <h2>联系方式</h2>
            <p>如果您对本隐私政策、本网站的做法或使用有任何疑问，可通过cooperation@shandaworld.cn联系我们。 </p>
            <h2>隐私政策的效力</h2>
            <p>本隐私政策自2022年8月17日起生效</p>
        </Modal>
    </div>
</template>

<script>
export default {
    name: "appointment",
    props: {
        tit: String,
        msg: String,
        projectId: Number,
        roomId: Number,
        recordType:Number,
        btnTxt:String,
    },
    data() {
        return {
            modal1: false,
            single: false,
            name: '',
            mobile: '',
            companyName:'',
            verifyCode: '',
            industry:'',
            demand:'',
            interestCommunity:'',
            saving: false,
            industryList: [
                // {
                //     value: 'New York',
                //     label: 'New York'
                // },
                // {
                //     value: 'London',
                //     label: 'London'
                // },
                // {
                //     value: 'Sydney',
                //     label: 'Sydney'
                // },
                // {
                //     value: 'Ottawa',
                //     label: 'Ottawa'
                // },
                // {
                //     value: 'Paris',
                //     label: 'Paris'
                // },
                // {
                //     value: 'Canberra',
                //     label: 'Canberra'
                // }
            ],
            shetuanList: [
                {
                    value: '电竞社',
                    label: '电竞社'
                },
                {
                    value: '桌游社',
                    label: '桌游社'
                },
                {
                    value: '烘焙社',
                    label: '烘焙社'
                },
                {
                    value: '足球社',
                    label: '足球社'
                },
                {
                    value: '篮球社',
                    label: '篮球社'
                },
                {
                    value: '读书会',
                    label: '读书会'
                },
                {
                    value: '相亲会',
                    label: '相亲会'
                },
                {
                    value: '徒步社',
                    label: '徒步社'
                },
                {
                    value: '羽球社',
                    label: '羽球社'
                },
                {
                    value: '戏剧社',
                    label: '戏剧社'
                }
            ],
            demandList: [
                {
                    value: '办公租赁',
                    label: '办公租赁'
                },
                {
                    value: '公寓租赁',
                    label: '公寓租赁'
                },
                {
                    value: '委托运营',
                    label: '委托运营'
                },
                {
                    value: '商务合作',
                    label: '商务合作'
                },
                {
                    value: '品牌合作',
                    label: '品牌合作'
                },
                {
                    value: '政策咨询',
                    label: '政策咨询'
                },
                {
                    value: '其他',
                    label: '其他'
                }
            ],
        }
    },
    methods: {
        getIndustrys() {
            this.loading = true;
            this.$http
                .get("/api/services/app/CommonWeb/GetDicitonaryItems?dicitionaryName=行业")
                .then((res) => {
                 this.industryList = res.data.result;
                })
                .finally(() => {
                this.loading = false;
                });
        },
        sendVerificationCode() {
            if (this.mobile == "" || this.mobile == null || this.mobile == " ") {
                alert("请填写手机号");
                return false;
            }
            if (!(/^(1[3-9][0-9])\d{8}$/.test(this.mobile))) {
                alert("请输入正确的手机号");
                return false;
            }
            let verification = {
                address: this.mobile,
                sendType: 0,
                token: Math.random() * 1000,
            };
            console.log(verification);
            this.saving = true;
            this.$http.post("/api/services/app/CommonWeb/SendVerificationCode", verification)
                .then(res => {
                    if (res.data.success) {
                        console.log(res.data)
                    }
                }).catch((error) => {
                    if (error.response.data) {
                        this.$Message.error(error.response.data.error.message);
                    }
                })
                .finally(() => {
                    this.saving = false;
                });
        },
        saveEntrust() {
            if (this.name == "" || this.name == null || this.name == " ") {
                this.$Message.error("请填写姓名");
                return false;
            }
            if (this.mobile == "" || this.mobile == null || this.mobile == " ") {
                this.$Message.error("请填写手机号");
                return false;
            }
            // if (this.verifyCode == "" || this.verifyCode == null || this.verifyCode == " ") {
            //     this.$Message.error("请填输入验证码");
            //     return false;
            // }
            let data = {
                recordType:this.recordType,
                name: this.name,
                mobile: this.mobile,
                companyName:this.companyName,
                projectId: this.projectId,
                roomId: this.roomId,
                industry:this.industry,
                demand:this.demand,
                interestCommunity:this.interestCommunity
            }
            console.log(data);
            this.saving = true;
            this.$http.post("/api/services/app/CommonWeb/SaveWebsiteRecord", data)
                .then(res => {
                    if (res.data.success) {
                        console.log(res.data)
                        alert("登记成功");
                    }
                    this.name="";
                    this.mobile="";
                    this.companyName="";
                    this.industry="";
                    this.demand="";
                    this.interestCommunity="";
                    this.single=false;
                }).catch((error) => {
                    if (error.response.data) {
                        this.$Message.error(error.response.data.error.message);
                    }
                })
                .finally(() => {
                    this.saving = false;
                });
        }
    },
    mounted() {
        if(this.recordType!=1){
         this.getIndustrys();
       }
    },

}
</script>

<style lang="less">
.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal{
        top: 0;
        /*height: 80%;*/
        /*overflow-y: scroll;*/
    }
}
.appointmentR {
    padding: 10px 20px;
    background-color: #FAFAFA;
    box-shadow: 0px 0px 1px 0px rgba(151, 151, 151, 0.8);

    .appointment-cont {

        /*align-items: flex-end;*/
        .box-input {
            padding-top: 10px;
            padding-bottom: 0;
            position: relative;
            .appoint-btn {
                width: 100%;
                margin-bottom: 3px;
            }

            .ivu-btn-large {
                height: 38px;
            }

            .ivu-btn-warning {
                background-color: #FF7043;
            }

            .ivu-input:focus {
                border-color: #57a3f3;
            }

            .ivu-checkbox-wrapper.ivu-checkbox-large {
                font-size: 12px;
                padding-bottom: 10px;
                color: #999;
            }
            .ivu-checkbox-checked .ivu-checkbox-inner {
                border-color: #FF7043;
                background-color: #FF7043;



            }
            .ftip-txt{
                position: absolute;
                right:10px;
                top:20px;
                color:#999;
            }
        }
    }
}
</style>